<template>
    <div :class="fieldErrors[id] ? 'error' : ''">
        <label class="block text-gray-700 text-sm font-semibold mb-2" :for="id" v-if="label">{{label}}</label>
        <div class="relative mt-10 mx-3">
            <vue-slider v-model="localValue" :tooltip="'always'"
                        :tooltip-formatter="tooltipFormat"
                        :min="min"
                        :max="max"
            ></vue-slider>
        </div>
        <div v-if="fieldErrors[id]" class="text-red-500 text-xs italic">
            {{fieldErrors[id]}}
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                localValue: this.value
            }
        },
        model: {
            prop: 'value',
            event: 'input'
        },
        props: {
            value: {},
            id: {
                type: String,
                required: true
            },
            label: {
                type: String
            },
            min: {
                type: Number,
                default: 0
            },
            max: {
                type: Number,
                default: 100
            },
            tooltipFormat: {
                type: String,
                default: '{value}'
            },
            fieldErrors: {
                type: Object,
                default: () => {
                    return {}
                }
            },
        },
        methods: {
            onChange() {
                this.$nextTick(() => {
                    this.$emit('change', this.localValue)
                })
            },
        },
        watch: {
            value(newVal) {
                this.localValue = newVal
            },
            localValue() {
                this.$emit('input', this.localValue)
            }
        },
    }
</script>
<style>
</style>
